import { z } from 'zod';

export const supportedLangs = ['en', 'fr', 'es', 'it', 'de'] as const;

export const SupportedLanguageSchema = z.enum(supportedLangs);

export type SupportedLangs = (typeof supportedLangs)[number];

export const defaultLang = 'en' as const;
export const supportedModelsLocales = ['en', 'fr'] as const;
export type SupportedModelsLocales = (typeof supportedModelsLocales)[number];
